/* Let's define a reusable regex for version sections (major, minor, patch, etc.)
* For example: 5.4.3-beta, the sections are [5, 4, 3-beta]
* Each section must be a * (wildcard) or start with one or more digits or letters, and optionally
* end with 1 or more dash followed by one or more letters/numbers or a *
*/
const versionSectionRegex = /(?:\*|(?:[\w:]+(?:[-+~](?:[\w]+|\*))*))/;

// construct reusable full version regex. Optional n number of version_sections followed by periods, ending in a version_section
const fullVersionRegex = new RegExp(`(?:${versionSectionRegex.source}\\.)*${versionSectionRegex.source}`, 'i');

// valid ranges: >=4.0.0, <4.0.0, <4.3.3, v4.0, go4.0, abc4.0
export const getNormalizedVersionRegex = () => new RegExp(`^(={1,2}|>|>=|<|<=|!=)?(?:[a-zA-Z]+)?(${fullVersionRegex.source})$`, 'i');

// constraints that need to be converted to normalized
export const getNonNormalVersionRegex = () => new RegExp(`^(~>|~|\\^)(?:v)?(${fullVersionRegex.source})$`, 'i');

// valid ranges: (1.0,), [1.0], (,1.0], (,1.0), [1.0,2.0], (1.0,2.0), [1.0,2.0), (1.0)
export const getIntervalRegex = () => {
  return new RegExp(`(\\(|\\[)(?:` + // starts with open bracket/parenthesis
    `(?:(,)(${fullVersionRegex.source}))` + // comma, then it ends with number [,6.0]
    `|` + // OR
    `(?:(${fullVersionRegex.source})(?:(,)|(?:(,)(${fullVersionRegex.source})))?)` + // number, or (number followed by comma OR number followed by comma and number): [6.0] [6.0,], [6.0,7.0]
    `)(\\)|\\])`, // ends with close bracket/parens
  'ig');
};

// valid ranges: 1.0 - 2.0. NOTE: whitespace must exist before and after hyphen, otherwise this: 1.0.beta-5 could be confused for a range
export const getRangeRegex = () => new RegExp(`^(?:v)?(${fullVersionRegex.source})(?:\\s\\-\\s)(?:v)?(${fullVersionRegex.source})$`, 'i');

export default {
  getNormalizedVersionRegex,
  getNonNormalVersionRegex,
  getIntervalRegex,
  getRangeRegex,
};
